// extracted by mini-css-extract-plugin
export default {"triangle":"RiS4JE","with-url":"VkcyvG","withUrl":"VkcyvG","icon":"lSa0cq","icon-scheduled":"DfW9b1","iconScheduled":"DfW9b1"};